import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function DevLogin() {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      alert('Please enter your name');
      return;
    }

    setLoading(true);
    
    // Simulate a brief loading state
    setTimeout(() => {
      // Store name in localStorage for use in survey
      localStorage.setItem('userName', name);
      localStorage.setItem('devMode', 'true');
      navigate('/home');
    }, 500);
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <h1 className="card-title">🏔️ Whistler Trip</h1>
          <p className="card-subtitle">
            Development Mode - Skip phone authentication for testing
          </p>
        </div>

        <div style={{ 
          background: '#fef5e7', 
          padding: '16px', 
          borderRadius: '12px', 
          marginBottom: '20px',
          border: '1px solid #f6e05e'
        }}>
          <p style={{ margin: 0, color: '#d69e2e', fontWeight: '600' }}>
            ⚠️ Development Mode: Phone authentication is disabled for testing
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">
              What's your name?
            </label>
            <input
              type="text"
              id="name"
              className="form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your full name"
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Continue (Dev Mode)'}
          </button>
        </form>

        <div style={{ 
          textAlign: 'center', 
          marginTop: '20px', 
          padding: '15px',
          background: '#f7fafc',
          borderRadius: '12px',
          border: '1px solid #e2e8f0'
        }}>
          <p style={{ 
            color: '#718096', 
            fontSize: '0.9rem',
            margin: 0
          }}>
            To enable phone authentication, configure Firebase Authentication in the console.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DevLogin;
